
import { Options } from "vue-class-component";

import { Col, Row, List } from "vant";
import BasePage from "@/common/BasePage"; // @ is an alias to /src
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [List.name]: List,
  },
})
export default class Index extends BasePage {
  // imgList = [];
  loading = false;
  finished = false;
  error = false;
  list: any[] = [];

  backcolor = "#ffffff";
  private reqData = { page: 0, limit: 10 };
  private onLoad() {
    // this.list=[1,2,3];
    // this.finished=true;
    this.reqData.page++;
    AppUtil.request(
      {
        url: "/zhTenant/tenant/getDisplayBoardImgList",
        method: "post",
        data: this.reqData,
      },
      this.req_items
    );
  }
  private req_items(res: any) {
    console.log("req_items", res);
    this.finished = true; //当res.data为空时，结束请求，兼容请求过程中后台新增情况
    this.loading = false;
    if (res.data && res.data.length) {
      res.data.map((val: any) => {
        val.thumb = this.get_thumb(val.imgUrl, 300, 200);
      });
      this.reqData.page > 1
        ? (this.list = this.list.concat(res.data))
        : (this.list = res.data);
      this.finished = this.list.length >= res.count; //通过数量判断是否已经结束
    }
  }
}
